import React, { useCallback } from 'react';

import { Button } from '../../index';

import styles from './styles.module.scss';

const MenorahStickyEnquire = () => {
  const handleClick = useCallback(() => {
    const el = document.getElementById('register');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className={styles.stickyEnquire}>
      <Button type="solidOrange" onClick={handleClick} large>
        Register Your Interest
      </Button>
    </div>
  );
};

export default MenorahStickyEnquire;
